import type { RootState } from "./state";

export const getters = {
  currentRoomState(state: RootState) {
    if (!state.currentRoomId) {
      return null;
    }
    return state.roomStates.get(state.currentRoomId) || null;
  },

  paginatedVoiceList(state: RootState) {
    const roomState = state.roomStates.get(state.currentRoomId || "");
    if (!roomState) {
      return [];
    }
    const start = (roomState.currentVoicePage - 1) * roomState.voicePageSize;
    const end = start + roomState.voicePageSize;
    return roomState.voiceList.slice(start, end);
  },

  // 从当前房间状态获取公共消息
  publicMessages(state: RootState) {
    const roomState = state.roomStates.get(state.currentRoomId || "");
    return roomState?.publicMessages || [];
  },

  // 全局状态的getters
  showProductSelector(state: RootState) {
    return state.showProductSelector;
  },

  products(state: RootState) {
    return state.products;
  },

  // 开播前预检查是否通过：预览播放器激活 或 队列播放器存在
  isAudioPrecheckPassed(state: RootState) {
    if (state.previewAudioActive) return true;
    const roomState = state.roomStates.get(state.currentRoomId || "");
    return !!(roomState as any)?.howlerPlayer;
  }
};
